import moment from "moment";
import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class Tempratuur extends Component {
  render() {
    const { sensor } = this.props;
    
    function value(data) {
      if (data && data[0] && data[0].value) {
        return data[0].value;
      } else {
        return 0;
      }
    }
    
    function luodate(data) {
      if (data && data[0] && data[0].datum) {
        return moment(data[0].datum).fromNow();
      } else {
        return null;
      }
    }

    // Safely get sensor values with defaults
    const currentTemp = value(sensor.data);
    const minTemp = sensor.minvaluetemp || -20;
    const maxTemp = sensor.maxvaluetemp || 50;
    const minGreen = sensor.minvalue || 18;
    const maxGreen = sensor.maxvalue || 25;

    // ApexCharts radial bar configuration with Sneat theme colors
    const getChartColor = () => {
      if (currentTemp < minGreen) return '#03c3ec'; // info color
      if (currentTemp > maxGreen) return '#ffab00'; // warning color  
      return '#71dd37'; // success color
    };

    const chartColor = getChartColor();

    const options = {
      chart: {
        type: 'radialBar',
        height: 350,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
        zoom: {
          enabled: false
        },
        fontFamily: 'Public Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 15,
            size: '65%',
            background: 'transparent',
            position: 'front',
            dropShadow: {
              enabled: false
            }
          },
          track: {
            background: '#f1f5f9',
            strokeWidth: '100%',
            margin: 15,
            dropShadow: {
              enabled: false
            }
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: -15,
              show: true,
              color: '#697a8d',
              fontSize: '16px',
              fontWeight: '500'
            },
            value: {
              formatter: function(val) {
                return currentTemp.toFixed(1) + '°C';
              },
              color: '#384551',
              fontSize: '32px',
              fontWeight: '600',
              show: true,
              offsetY: 8
            },
            total: {
              show: false
            }
          }
        }
      },
      fill: {
        type: 'solid',
        colors: [chartColor]
      },
      stroke: {
        lineCap: 'round'
      },
      labels: ['Temperatuur'],
      colors: [chartColor],
      grid: {
        padding: {
          top: -10,
          bottom: -10
        }
      }
    };

    // Calculate percentage for radial bar (0-100)
    const percentage = ((currentTemp - minTemp) / (maxTemp - minTemp)) * 100;
    const clampedPercentage = Math.max(0, Math.min(100, percentage));

    const series = [clampedPercentage];

    // Get temperature status for styling
    const getTemperatureStatus = () => {
      if (currentTemp < minGreen) return { status: 'cold', color: 'info', label: 'Koud' };
      if (currentTemp > maxGreen) return { status: 'hot', color: 'warning', label: 'Warm' };
      return { status: 'optimal', color: 'success', label: 'Optimaal' };
    };

    const tempStatus = getTemperatureStatus();
    const lastUpdate = luodate(sensor.data);

    return (
      <div className="w-100">
        {/* Header with status info */}
        <div className="d-flex justify-content-between align-items-start mb-4">
          <div className="d-flex align-items-center">
            <div className="avatar avatar-sm me-3">
              <span className="avatar-initial rounded-circle bg-label-primary">
                <i className="bx bx-thermometer"></i>
              </span>
            </div>
            <div>
              <h6 className="mb-1">Huidige Temperatuur</h6>
              <small className="text-muted">Real-time meting</small>
            </div>
          </div>
          <div className="text-end">
            <span className={`badge bg-label-${tempStatus.color} mb-1`}>{tempStatus.label}</span>
            {lastUpdate && (
              <div>
                <small className="text-muted d-block">
                  <i className="bx bx-time-five me-1"></i>
                  {lastUpdate}
                </small>
              </div>
            )}
          </div>
        </div>

        {/* Chart section */}
        <div className="row mb-4">
          <div className="col-12">
            {sensor.data && sensor.data.length > 0 ? (
              <div className="text-center">
                <Chart
                  options={options}
                  series={series}
                  type="radialBar"
                  height={350}
                />
                <div className="mt-3">
                  <div className="d-flex justify-content-between text-muted" style={{ fontSize: '0.875rem' }}>
                    <span>Min {minTemp}°C</span>
                    <span>Optimaal {minGreen}°C - {maxGreen}°C</span>
                    <span>Max {maxTemp}°C</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center" style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div>
                  <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h6 className="text-muted mb-1">Temperatuurdata laden...</h6>
                  <small className="text-muted">
                    Even geduld terwijl we de laatste metingen ophalen.
                  </small>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Temperature info section */}
        <div className="row g-3">
          {/* Current value - first position */}
          <div className="col-lg-3 col-md-6 col-12 order-1">
            <div className="text-center p-4 bg-light rounded">
              <div className={`avatar avatar-lg mx-auto mb-3`}>
                <span className={`avatar-initial rounded-circle bg-label-${tempStatus.color}`}>
                  <i className="bx bx-thermometer fs-4"></i>
                </span>
              </div>
              <div className="fw-bold fs-2 text-heading">{currentTemp.toFixed(1)}°C</div>
              <small className="text-muted">Huidige temperatuur</small>
            </div>
          </div>

          {/* Status description - second position */}
          <div className="col-lg-3 col-md-6 col-12 order-2">
            <div className="text-center p-4 bg-light rounded h-100 d-flex flex-column justify-content-center">
              <span className={`badge bg-label-${tempStatus.color} mb-2 mx-auto`} style={{ width: 'fit-content' }}>{tempStatus.label}</span>
              <small className="text-muted">
                {tempStatus.status === 'cold' && 'Temperatuur onder optimaal'}
                {tempStatus.status === 'hot' && 'Temperatuur boven optimaal'}  
                {tempStatus.status === 'optimal' && 'Temperatuur optimaal'}
              </small>
            </div>
          </div>

          {/* Optimal range - third position */}
          <div className="col-lg-3 col-md-6 col-12 order-3">
            <div className="d-flex align-items-center p-4 bg-light rounded h-100">
              <div className="avatar avatar-md me-3">
                <span className="avatar-initial rounded-circle bg-label-success">
                  <i className="bx bx-target-lock"></i>
                </span>
              </div>
              <div className="flex-grow-1">
                <div className="fw-bold h5 mb-1">{minGreen}°C - {maxGreen}°C</div>
                <small className="text-muted">Optimaal bereik</small>
              </div>
            </div>
          </div>

          {/* Min/Max range - fourth position */}
          <div className="col-lg-3 col-md-6 col-12 order-4">
            <div className="d-flex align-items-center p-4 bg-light rounded h-100">
              <div className="avatar avatar-md me-3">
                <span className="avatar-initial rounded-circle bg-label-secondary">
                  <i className="bx bx-chart"></i>
                </span>
              </div>
              <div className="flex-grow-1">
                <div className="fw-bold h5 mb-1">{minTemp}°C - {maxTemp}°C</div>
                <small className="text-muted">Min - Max bereik</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
